import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { IRequestiesResponse } from '@/entities/booking'

export const mockGetBookingRequests = http.get(
  '/api/booking/v1/bookings/policies/find',
  () => {
    const response: IRequestiesResponse = {
      timestamp: new Date(),
      data: Array.from({ length: 100 }).map(() => ({
        bookingId: faker.number.int({ min: 10000, max: 99999 }),
        company: {
          id: faker.number.int({ min: 10000, max: 99999 }),
          name: faker.company.name(),
        },
        created: faker.date.past().toISOString(),
        createdByUserId: faker.number.int({ min: 10000, max: 99999 }),
        createdByUserName: faker.person.fullName(),
        responseByUserId: faker.number.int({ min: 10000, max: 99999 }),
        responseByUserName: faker.person.fullName(),
        endDate: faker.date.future().toISOString(),
        guest: Array.from({ length: faker.number.int({ min: 1, max: 2 }) }).map(
          () => ({
            email: faker.internet.email(),
            name: faker.person.firstName(),
            surName: faker.person.lastName(),
            ageGroup: 'ADULT',
          }),
        ),
        hotel: {
          id: faker.number.int({ min: 10000, max: 99999 }),
          name: faker.company.name(),
        },
        hotelChain: {
          id: faker.number.int({ min: 10000, max: 99999 }),
          alphaId: faker.string.uuid(),
          name: faker.company.name(),
        },
        observationRequest: faker.lorem.paragraph(),
        responseByUser: faker.number.int({ min: 10000, max: 99999 }),
        roomType: {
          id: faker.number.int({ min: 10000, max: 99999 }),
          description: faker.lorem.sentence(),
          classification: faker.lorem.word(),
          value: faker.number.float({ min: 100, max: 500 }),
        },
        startDate: faker.date.past().toISOString(),
        status: faker.helpers.arrayElement(['WAIT', 'RELEASED', 'DENIED']),
        typeRequest: faker.lorem.word(),
      })),
    }

    return HttpResponse.json({ ...response })
  },
)
